<template>
  
  <!-- This menu is rendered eagerly so the hotkeys item can be triggered with a hotkey. -->
  <v-menu 
    offset-y 
    left
    eager
  >

    <template v-slot:activator="{ on }">
      <v-btn
        icon
        dark
        v-on    = "on"
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <Version></Version>
      <UserGuide></UserGuide>
      <User
        v-if              = "isAuthenticationEnabled"
        :user             = "user.name"
        :authentication   = "user.authenticationType"
        :is-authenticated = "user.isAuthenticated"
        :groups           = "user.groups"
      >
      </User>
    
      <!-- Support -->
      <v-list-item
        href    = "http://www.telestream.net/telestream-support/glim/support.htm"
        target  = "_blank"
      >
        <v-list-item-icon>
          <v-icon>mdi-face-agent</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Support
        </v-list-item-content>
      </v-list-item>

      <!-- Hotkeys -->
      <HotkeyDialog ref="hotkeys"></HotkeyDialog>

      <!-- Reset Layout -->
      <v-list-item
        @click    = "onResetLayout"
      >
        <v-list-item-icon>
          <v-icon>mdi-undo</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Restore Default Spacing
        </v-list-item-content>
      </v-list-item>

      <v-divider class="my-2"></v-divider>

      <!-- Settings -->
      <v-list-item
        v-if  = "isUserAdmin"
        to    = "/settings"
      >
        <v-list-item-icon>
          <v-icon>mdi-cog</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Settings
        </v-list-item-content>
      </v-list-item>

      <!-- Layout Configuration -->
      <v-list-item
        v-if  = "isUserAdmin"
        to    = "/layout"
      >
        <v-list-item-icon>
          <v-icon>mdi-grid</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Layout Configuration
        </v-list-item-content>
      </v-list-item>

      <!-- System -->
      <v-list-item
        v-if  = "isUserAdmin"
        to    = "/system"
      >
        <v-list-item-icon>
          <v-icon>mdi-network</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          System
        </v-list-item-content>
      </v-list-item>

      <!-- Sessions -->
      <v-list-item
        v-if  = "isUserAdmin"
        to    = "/sessions"
      >
        <v-list-item-icon>
          <v-icon>mdi-account-box-multiple</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Sessions
        </v-list-item-content>
      </v-list-item>

      <!-- Logs -->
      <v-list-item
        v-if    = "isUserAdmin"
        href    = "support/logs"
        target  = "_blank"
      >
        <v-list-item-icon>
          <v-icon>mdi-download</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Logs
        </v-list-item-content>
      </v-list-item>

    </v-list>

  </v-menu>

</template>

<script lang="js">

// #region Imports

/* vuex */
import { mapState } from 'vuex';

/* Telestream */
import User from '@/components/app-user-info/User';
import UserGuide from '@/components/app-user-info/UserGuide';
import Version from '@/components/app-user-info/Version';
import HotkeyDialog from './HotkeyDialog';
import { AllowedViews } from '@/services/allowed-views-service';
import { RESTORE_LAYOUT } from '@/utils/action-types';

// #endregion Imports

export default {

  // #region Properties

  name:       'ApplicationMenu',
  components: {
    HotkeyDialog,
    User,
    UserGuide,
    Version
  },
  computed: {
    ...mapState([
      'user'
    ]),
    isAuthenticationEnabled() {
      return (this.user.authenticationType !== 'None');
    },
    isUserAdmin() {
      return this.user.hasAccessTo.has(AllowedViews.Admin);
    }
  },

  // #endregion Properties

  // #region Methods

  methods: {

    // #region Events

    onResetLayout() {
      this.$store.dispatch(RESTORE_LAYOUT);
    }

    // #endregion Events

  }

  // #endregion Methods

}

</script>